module.exports = __webpack_public_path__ + "media/tray_selector/School-Tray-028f43c7.png";